import axios from '@/js/lib/helper/axios';
import { toCamelCaseKeys } from '@/js/lib/helper/localize-keys';
import { updateToken } from './update_token';

export interface Member {
  memberId: number;
  memberName: string;
  alias: string;
  imagePath: string;
}

export const getMember = async (memberId: number): Promise<{ member: Member }> => {
  const res = await axios.get(`/api/member/${memberId}`);
  return toCamelCaseKeys(res.data);
};

export const followMember = async ({ memberId }: { memberId: number }): Promise<''> => {
  const token = await updateToken();
  const params = new URLSearchParams();
  params.append('member_id', String(memberId));
  params.append('token', token);
  const res = await axios.post('/api/like/member', params);
  return res.data;
};

export const unFollowMember = async ({ memberId }: { memberId: number }): Promise<''> => {
  const token = await updateToken();
  const params = new URLSearchParams();
  params.append('member_id', String(memberId));
  params.append('token', token);
  const res = await axios.post('/api/like/unlink/member', params);
  return res.data;
};

export const isMemberFollowing = async ({
  memberIds,
}: {
  memberIds: number[];
}): Promise<
  {
    liked: 0 | 1;
    memberId: string;
  }[]
> => {
  const res = await axios.get('/api/is-liked/members', {
    params: {
      member_ids: memberIds.join(','),
    },
  });
  return toCamelCaseKeys(res.data);
};
